/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCompass: {
  name: 'compass';
  data: string;
} = {
  name: 'compass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm3.316 9.214c.521-1.564-.966-3.051-2.53-2.53l-2.128.71a2 2 0 0 0-1.265 1.264l-.71 2.128c-.52 1.564.967 3.051 2.53 2.53l2.129-.71a2 2 0 0 0 1.265-1.264l.71-2.128Zm-4.025.077 2.128-.71-.71 2.128-2.128.71.71-2.128Z" fill="currentColor"/></svg>`,
};
